import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import CartLoader from "../../../Helper/Loaders/CartLoader";
import { useBaseEntityInfo } from "../../../Hooks/usePagesContent";
import RangeKPISection from "./RangeKPISection";
import FleetRangeDistributionChart from "./FleetRangeDistributionChart";

// ─── Main component ─────────────────────────────────────────────────────────────
const RangeTab = ({
  startDate,
  endDate,
  vehiclesConnected,
  isLoadingVehiclesCount,
  globalFilters = {},
}) => {
  const { baseEntityTypePluralLable } = useBaseEntityInfo();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, maxWidth: 'calc(100vw - 102px)' }}>

      {/* ── KPI Header ────────────────────────────────────────────────────── */}
      <Grid2 container alignItems="center" justifyContent="space-between">
        <Box>
          <Typography
            variant="fw400s20c000"
            sx={{ lineHeight: "28px", fontWeight: 300 }}
          >
            Key Performance Indicators
          </Typography>
        </Box>
        {isLoadingVehiclesCount ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              height: "16px",
              padding: "8px 16px",
            }}
          >
            <CartLoader />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              padding: "8px 16px",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="fw400s16c000000"
              sx={{ color: "#444B51", lineHeight: "16px" }}
            >
              Connected {baseEntityTypePluralLable} Today :
            </Typography>
            <Typography
              variant="fw400s16c000000"
              sx={{ fontWeight: 600, color: "#2E2E2E", lineHeight: "16px" }}
            >
              {vehiclesConnected.toLocaleString()}
            </Typography>
          </Box>
        )}
      </Grid2>

      {/* ── KPI Section ───────────────────────────────────────────────────── */}
      <RangeKPISection
        vehiclesConnected={vehiclesConnected}
        showHeader={false}
      />

      {/* ── Range Section ─────────────────────────────────────────────────── */}
      <Box>
        <Typography
          variant="fw400s20c000"
          sx={{ lineHeight: "28px", fontWeight: 300 }}
        >
          Range
        </Typography>
      </Box>

      <FleetRangeDistributionChart
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
      />

    </Box>
  );
};

export default RangeTab;
